/**
 * Scalimmo Logo Variants — 3 propositions premium navy + gold
 *
 * Toutes les options utilisent un SVG inline → vectoriel, scalable, ultra-net à toute taille.
 * Couleurs: NAVY #0e1d3a, GOLD #d4af37
 */

const NAVY = '#0e1d3a';
const GOLD = '#d4af37';

/**
 * Option A: "Toit + S" — La plus thématique immobilier
 * Carré navy arrondi avec chevron/toit gold au-dessus d'un S serif gold.
 */
export const LogoMarkA = ({ size = 40, className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Scalimmo"
    >
        <rect width="48" height="48" rx="10" fill={NAVY} />
        {/* Roof/chevron */}
        <path
            d="M11 21 L24 11 L37 21 L33 21 L24 14 L15 21 Z"
            fill={GOLD}
        />
        {/* S serif */}
        <text
            x="24"
            y="38"
            textAnchor="middle"
            fontFamily="Playfair Display, Georgia, serif"
            fontWeight="700"
            fontSize="22"
            fill={GOLD}
        >
            S
        </text>
    </svg>
);

/**
 * Option B: "Pure S" — La plus minimaliste & premium
 * Juste un grand S serif gold dans un carré navy. Élégance maximale.
 */
export const LogoMarkB = ({ size = 40, className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Scalimmo"
    >
        <rect width="48" height="48" rx="10" fill={NAVY} />
        <text
            x="24"
            y="36"
            textAnchor="middle"
            fontFamily="Playfair Display, Georgia, serif"
            fontWeight="700"
            fontSize="36"
            fill={GOLD}
        >
            S
        </text>
    </svg>
);

/**
 * Option C: "Maison stylisée" — Iconique & moderne
 * Forme de maison (toit + base) en gold sur navy, sans lettre.
 * Très moderne, type pictogramme.
 */
export const LogoMarkC = ({ size = 40, className = '' }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        aria-label="Scalimmo"
    >
        <rect width="48" height="48" rx="10" fill={NAVY} />
        {/* Maison stylisée: toit triangle + corps */}
        <path
            d="M24 12 L36 22 L36 36 L12 36 L12 22 Z"
            fill="none"
            stroke={GOLD}
            strokeWidth="2.5"
            strokeLinejoin="round"
        />
        <path
            d="M10 23 L24 12 L38 23"
            stroke={GOLD}
            strokeWidth="2.5"
            strokeLinejoin="round"
            strokeLinecap="round"
            fill="none"
        />
        {/* Petit S signature au centre */}
        <text
            x="24"
            y="33"
            textAnchor="middle"
            fontFamily="Playfair Display, Georgia, serif"
            fontWeight="700"
            fontSize="14"
            fill={GOLD}
        >
            S
        </text>
    </svg>
);

/**
 * Wordmark "Scalimmo" en navy serif (couleur de marque principale, accent doré réservé au "S" du logo)
 */
export const ScalimmoWordmark = ({ size = 'md', className = '', variant = 'navy' }) => {
    const fontSize = size === 'sm' ? 'text-lg' : size === 'lg' ? 'text-3xl' : 'text-2xl';
    const color = variant === 'gold' ? GOLD : variant === 'white' ? '#ffffff' : '#0e1d3a';
    return (
        <span
            className={`font-heading font-semibold tracking-tight ${fontSize} ${className}`}
            style={{ color, fontFamily: '"Playfair Display", Georgia, serif' }}
        >
            Scalimmo
        </span>
    );
};

/**
 * Composant Logo complet (mark + wordmark) pour navbar/footer
 */
export const ScalimmoLogo = ({ variant = 'A', size = 40, wordmarkSize = 'md', showWordmark = true, className = '' }) => {
    const Mark = variant === 'B' ? LogoMarkB : variant === 'C' ? LogoMarkC : LogoMarkA;
    return (
        <div className={`flex items-center gap-2.5 ${className}`}>
            <Mark size={size} />
            {showWordmark && <ScalimmoWordmark size={wordmarkSize} />}
        </div>
    );
};
